import { useState } from "react";
import { ghostBtnClass, inputClass } from "@/components/common/surfaceClasses";
import type { SsdGoogleConversions } from "@/lib/ssdSalesClient";

export function AudienceDataGoogleConversionNameFields(props: {
  conversions: SsdGoogleConversions;
  saving: boolean;
  onSelect: (name: string) => void;
  onAdd: (name: string) => void;
}) {
  const [draft, setDraft] = useState("");
  return (
    <div className="min-w-0 space-y-2">
      <label className="block min-w-0 text-sm text-gray-700 dark:text-zinc-300">
        Conversion Name
        <select
          className={`mt-1 ${inputClass}`}
          value={props.conversions.selected}
          disabled={props.saving}
          onChange={(e) => props.onSelect(e.target.value)}
        >
          {props.conversions.names.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
      </label>
      <div className="flex min-w-0 flex-wrap items-end gap-2">
        <label className="min-w-0 flex-1 text-sm text-gray-700 dark:text-zinc-300">
          Add a name
          <input
            className={`mt-1 ${inputClass}`}
            value={draft}
            disabled={props.saving}
            placeholder="e.g. Offline Shed Sales"
            onChange={(e) => setDraft(e.target.value)}
          />
        </label>
        <button
          type="button"
          className={ghostBtnClass}
          disabled={props.saving || !draft.trim()}
          onClick={() => {
            const name = draft.trim();
            if (!name) return;
            props.onAdd(name);
            setDraft("");
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
}
